import {Component, forwardRef, Injector, Input, OnInit, inject} from '@angular/core';
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FooControlComponent} from "../foo-control/foo-control.component";

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FooDatepickerComponent),
  multi: true
};

@Component({
  selector: 'foo-datepicker',
  templateUrl: './foo-datepicker.component.html',
  styleUrls: ['./foo-datepicker.component.scss'],
  providers: [
    CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR,
  ]
})
export class FooDatepickerComponent extends FooControlComponent implements OnInit {

  @Input() placeholder: string;
  @Input() clearable: boolean;

  constructor(
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  get iconUrl(): string {
    return this.templateOptions?.iconUrl || 'assets/img/calendar.svg';
  }

  get icon(): string {
    return this.templateOptions?.icon || 'foo-calendar-primary';
  }

  get maxDate(): any {
    if (this.templateOptions?.max === 'now') {
      return new Date();
    }
    return this.templateOptions?.max;
  }

  get minDate(): any {
    if (this.templateOptions?.min === 'now') {
      return new Date();
    }
    return this.templateOptions?.min;
  }

  clearInput() {
    this.control.setValue(null);
  }
}
